module.exports = __webpack_public_path__ + "r-v3/img/screen_increase_white.d73dc57d.svg";